const SLUG_BY_SOURCE = {
  Salary: 'salary',
  Business: 'business',
  Profession: 'profession',
  'House Property': 'house_property',
  'Capital Gains': 'capital_gains',
  'Other Sources': 'other_sources',
  'Multiple Sources': 'multiple_sources',
};

export function incomeSourceSlug(source) {
  return SLUG_BY_SOURCE[source] ?? String(source || '').toLowerCase().replace(/\s+/g, '_');
}

export function translateIncomeSource(t, source) {
  const slug = incomeSourceSlug(source);
  return t(`income.source.${slug}`, source);
}

export function translateItrGuideField(t, guideItem, field) {
  if (!guideItem) return '';
  const slug = incomeSourceSlug(guideItem.source);
  const fallback = guideItem[field] ?? '';
  return t(`itr.guide.${slug}.${field}`, fallback);
}
